export class ImagePaths {
    static appLogo = require("../assets/svg/appLogo.svg");
    static loginLogo = require("../assets/svg/LoginLogo.svg");
    static home = require("../assets/svg/home.svg");
    static dashboard = require("../assets/svg/home.svg");
}